<template>
  <div v-loading="loading">
    <search-base ref="SearchBase" :data="formData" @search="onSearch">
      <template v-slot:footer>
        <el-col :span="16">
          <el-form-item label="评审机构" prop="boardName">
            <el-row>
              <el-col :span="19">
                <el-input
                  v-model="boardName"
                  readonly
                  placeholder="请单击后面的按钮选择"
                ></el-input>
              </el-col>
              <el-col :span="4" :offset="1" class="text-right">
                <el-button
                  icon="el-icon-delete"
                  title="清空"
                  @click="onClear"
                ></el-button>
                <el-button icon="el-icon-search" @click="onBoard"></el-button>
              </el-col>
            </el-row>
          </el-form-item>
        </el-col>
      </template>
    </search-base>
    <search-board ref="SearchBoard" @selectd="onSelectd"></search-board>
  </div>
</template>

<script>
import SearchBase from './components/Base.vue';
import SearchBoard from '@/components/SearchBoard/Index.vue';

import { getAdmin } from '@/api/search/gain.js';

export default {
  data() {
    return {
      loading: false,
      query: {},
      formData: {},
      boardName: ''
    };
  },
  components: {
    SearchBase,
    SearchBoard
  },
  methods: {
    onSearch(queryParams) {
      Object.assign(queryParams, this.query);
      this.$emit('search', queryParams);
    },
    onSelectd(boardId, boardName) {
      this.query.boardId = boardId;
      this.boardName = boardName;
    },
    onBoard() {
      this.$refs.SearchBoard.show();
    },
    onClear() {
      this.onSelectd(0, '');
    },
    getData() {
      this.loading = true;
      getAdmin(this.query)
        .then(res => {
          this.formData = res;
        })
        .finally(() => {
          this.loading = false;
        });
    }
  },
  created() {
    this.getData();
  }
};
</script>

<style></style>
